import * as React from 'react';
import './loader.css'
interface ISexLoaderProps {
}

export const SexLoader: React.SFC<ISexLoaderProps> = (props) => {
    return (
        <div className="animated-background sexLoader">
            <svg width="100%" height="100%" id="SexLoader">
                <defs>
                    <mask id="sexmask">
                        <rect width="100%" height="100%" fill="white" />
                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="270px" height="254px" viewBox="0 0 2700 2540" preserveAspectRatio="xMidYMid meet">
                            <g id="layer101" fill="#0092a0" stroke="none">
                                <path d="M1160 2443 c-403 -65 -742 -316 -910 -675 -77 -165 -110 -316 -110 -509 0 -321 109 -593 329 -822 166 -173 343 -276 581 -339 97 -25 344 -36 461 -19 379 55 733 320 899 673 66 142 110 318 110 446 l0 63 -142 -3 -143 -3 -7 -80 c-9 -107 -31 -193 -79 -293 -52 -112 -112 -194 -207 -283 -172 -161 -374 -240 -612 -240 -173 0 -322 41 -478 133 -73 43 -247 217 -290 290 -93 157 -132 300 -132 478 0 178 39 321 132 478 43 73 217 247 290 290 157 93 300 132 478 132 245 0 440 -77 618 -245 154 -145 249 -325 277 -525 l7 -46 140 13 c77 6 142 14 145 16 7 8 -17 133 -43 223 -107 371 -396 671 -765 795 -52 17 -128 37 -169 45 -69 12 -320 17 -380 7z" />
                            </g>
                            <g id="layer102" fill="#ffffff" stroke="none">
                                <path d="M0 1270 l0 -1270 1350 0 1350 0 0 1270 0 1270 -1350 0 -1350 0 0 -1270z m1540 1166 c171 -31 360 -113 500 -217 207 -154 364 -379 434 -623 26 -90 50 -215 43 -223 -3 -2 -68 -10 -145 -16 l-140 -13 -7 46 c-28 200 -123 380 -277 525 -178 168 -373 245 -618 245 -178 0 -321 -39 -478 -132 -73 -43 -247 -217 -290 -290 -93 -157 -132 -300 -132 -478 0 -178 39 -321 132 -478 43 -73 217 -247 290 -290 156 -92 305 -133 478 -133 238 0 440 79 612 240 171 160 268 356 286 576 l7 80 143 3 142 3 0 -63 c0 -183 -79 -424 -197 -601 -62 -93 -188 -225 -283 -296 -147 -109 -355 -197 -529 -222 -117 -17 -364 -6 -461 19 -238 63 -415 166 -581 339 -220 229 -329 501 -329 822 0 144 9 212 46 338 53 182 145 342 279 482 189 199 420 320 695 364 60 10 311 5 380 -7z" />
                            </g>
                        </svg>
                    </mask>
                </defs>
                <rect width="100%" height="100%" fill="white" mask="url(#sexmask)" />
            </svg>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/share/components/ChartLoader/SexLoader.tsx